module.exports = __webpack_public_path__ + "static/media/mark-casual-1.5acdd2e2.jpg";